import { CloudinaryEvent, Event, UploadInterface } from "cloudinary-core";

import { cloudinaryPresets } from "./presets";

export const openCloudinaryUploadWidget = ({
  onError,
  onSuccess,
  preset,
  config,
}: {
  onSuccess: (file: Event<"success">) => void;
  onError?: (error: string, file: Event<CloudinaryEvent>) => void;
  config?: Partial<UploadInterface>;
  preset: keyof typeof cloudinaryPresets;
}) => {
  const buildOptions: UploadInterface = {
    cloudName: "brandhub",
    showUploadMoreButton: false,
    ...cloudinaryPresets[preset],
    ...config,
  };
  window.cloudinary.openUploadWidget(buildOptions, (error, file) => {
    if (error) onError?.(error, file);
    if (file.event === "success") onSuccess(file);
  });
};
